/**
 * @file
 * Image gallery paragraph behaviors.
 */
(function (Drupal, once, Splide) {

  /**
   * Navigate to a specific slide in both Splide instances.
   *
   * @param {Splide} imagesSplide
   *   The main image slider instance.
   * @param {number} slideIndex
   *   The slide number (1-based).
   */
  function goToSlide(imagesSplide, slideIndex) {
    if (!slideIndex) return;

    const index = slideIndex - 1;
    imagesSplide.go(index);
  }

  /**
   * Attach the splide carousel in the Image gallery paragraph.
   */
  Drupal.behaviors.imageGalleryParagraphSlider = {
    attach: function attach(context) {
      const imageGalleryParagraphs = once("imageGalleryParagraphSlider", ".paragraph--type--image-gallery", context);

      imageGalleryParagraphs.forEach(function (imageGalleryParagraph) {
        const thumbnails = imageGalleryParagraph.querySelectorAll(".images__image");
        const otherImages = imageGalleryParagraph.querySelector(".images__other-images");
        const splideImages = imageGalleryParagraph.querySelector(".splide.images");
        const splideThumbnails = imageGalleryParagraph.querySelector(".splide.thumbnails");
        const imageGalleryModal = imageGalleryParagraph.querySelector(`[id^="imageGalleryModal-"]`);

        if (!thumbnails || !splideImages || !splideThumbnails) return;

        const imagesSplide = new Splide(splideImages, {
          type: "fade",
          rewind: true,
          arrows: true,
          pagination: false,
          perPage: 1,
          mediaQuery: "min"
        });

        imagesSplide.mount();

        const thumbnailsSplide = new Splide(splideThumbnails, {
          type: "slide",
          pagination: false,
          arrows: true,
          isNavigation: true,
          gap: ".75rem",
          perMove: 1,
          fixedWidth: 140,
          fixedHeight: 82,
          updateOnMove: true,
        }).mount();

        imagesSplide.sync(thumbnailsSplide);

        imagesSplide.on('move', (newIndex) => {
          thumbnailsSplide.go(newIndex);
        });

        thumbnails.forEach(thumbnail => {
          thumbnail.addEventListener("click", () => {
            const slideIndex = parseInt(thumbnail.dataset.slideNumber, 10);
            goToSlide(imagesSplide, slideIndex);
          });
        });

        if (otherImages) {
          otherImages.addEventListener("click", () => {
            const slideIndex = parseInt(otherImages.dataset.slideNumber, 10);
            goToSlide(imagesSplide, slideIndex);
          });
        }
        if (imageGalleryModal) {
          imageGalleryModal.addEventListener('shown.bs.modal', () => {
            thumbnailsSplide.refresh();
            imageGalleryModal.querySelector('.splide.thumbnails').style.visibility = 'visible';
          });
        }
      });
    }
  };
})(Drupal, once, Splide);
